import React from 'react';
import { MENU_STYLE } from '@sonifi/wb-hotel-directory/constants/wbHDContansts';
import styles from '../../../styles/WbAdmin.module.css';

const options = [
  { label: 'Horizontal', value: MENU_STYLE.horizontal },
  { label: 'Vertical', value: MENU_STYLE.vertical },
  { label: 'Grid', value: MENU_STYLE.grid },
  { label: 'Simple Grid', value: MENU_STYLE.simpleGrid },
];

const HotelDirectory = ({ register, getValues }) => (
  <div className="col-md-offset-1">
    <label className="pull-left control-label">TV menu style:</label>
    <div className="col-md-3">
      <select
        className="form-control"
        {...register('products.hotel_directory.settings.tv_menu_style')}
        value={getValues('products.hotel_directory.settings.tv_menu_style')}
      >
        {options.map((option) => (
          <option key={option.label} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
    <div className={styles.helpTvMenuStyle}>
      <em>
        Not all layouts are supported in all systems, please verify results on a
        live system
      </em>
    </div>

    <br />

    <input
      className="form-control"
      type="checkbox"
      data-testid="enable-qr-codes"
      {...register(
        'products.hotel_directory.settings.enable_qr_codes',
      )}
    />
    <label>Enable QR Codes</label>

    <br />
    <br />

    <input
      className="form-control"
      type="checkbox"
      data-testid="enable-fullscreen-image-regions"
      {...register(
        'products.hotel_directory.settings.enable_fullscreen_image_regions',
      )}
    />
    <label>Enable Full Screen Images</label>
  </div>
);

export default HotelDirectory;
